import React from 'react';
import { Link } from 'react-router-dom';
import PrimaryctaLong from '../components/common/primary cta long';
import SecondaryctaLong from '../components/common/seconday cta long';
import pic4 from '../assets/pic4.png'
import './characters.css'
import Header from '../components/layout/header';
import pic9 from '../assets/pic9.png'
import pic11 from '../assets/pic11.png'
import pic24 from '../assets/pic24.png'
import Charcterswitch from '../components/common/characterswitch';
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic29 from '../assets/pic29.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import Settings from '../components/common/settings';
import { useState } from 'react';
import SecondaryctaLongsettings from '../components/common/settings-secondary-cta';
import { useEffect } from 'react';

const Characters = () => {
      const [settingsOpen, setSettingsOpen] = useState(false);
     const [activeIndex, setActiveIndex] = useState(0);
        // const [selectedCharacter, setSelectedCharacter] = useState(
        //     Number(localStorage.getItem('selectedCharacter')) || 0
        // );
     const character2Unlocked =
    localStorage.getItem('character2Unlocked') === 'true';
    const character3Unlocked =
    localStorage.getItem('character3Unlocked') === 'true';
     const character4Unlocked =
    localStorage.getItem('character4Unlocked') === 'true';
      const character5Unlocked =
    localStorage.getItem('character5Unlocked') === 'true';   
   

const [selectedCharacter, setSelectedCharacter] = useState(
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout'
);

useEffect(() => {
    const stored = localStorage.getItem('selectedCharacter') || 'Mohammed Tout';
    setSelectedCharacter(stored);
}, []);

    const characters = [
        { img: pic27, name: 'Mohammed Tout', unlocked: true },

        {
            img: pic28,
            name: 'Sarah Idress',
            unlocked: character2Unlocked
        },

        {
            img: pic29,
            name: 'Teyah Ramses',
            unlocked: character3Unlocked
        },

        { img: pic30,
            name: 'Ahmad Amon',
            unlocked: character4Unlocked },

        { img: pic31, 
            name: 'Mariam Lotus',
             unlocked: character5Unlocked },
    ];

    const prev = () => setActiveIndex(i => Math.max(i - 1, 0));
    const next = () => setActiveIndex(i => Math.min(i + 1, characters.length - 1));

const handleSelectCharacter = (name) => {
    setSelectedCharacter(name);
    localStorage.setItem('selectedCharacter', name);
};
    // const handleSelect = (name) => {
    //     localStorage.setItem('selectedCharacter', name);
    //     setSelectedCharacter(name);
    // };


    return ( 

          <main className='charcterr-page'>
            <section className='charcpage-container'>
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
             <section className='container-items-home-page'>
               <section className='container-charcater-page'>

               
                        <div className='game-title-logo'>
                            <h1 className='game-name'>Desert Treasure Run</h1>
                                <h1 className='text-effect'>Desert Treasure Run</h1>
                        </div>

                    </section>

                    <div className='container-ctas-charcter2'>
                        <Link to='/levels' className='home-link'>
                        <PrimaryctaLong title='Play Now'/>
                        </Link>
                        <SecondaryctaLong title='Settings'/>
                        <SecondaryctaLong title='Characters'/>
                    </div>
            </section>
   
                <section className='container-header-and-characterswitch'>
                    <Header 
                    title='Characters' title2='Characters'
                    link='/home'   onClick={() => setSettingsOpen(true)}
                    img={pic9} icontext='Return icon'
                    img2={pic11} icontext2='settings icon'/>

                <div className='carousel-wrapper'>
                    <section
                        className='row-character-switch'
                        style={{ transform: `translateX(-${activeIndex * 100}%)` }} >
                        {characters.map((char, i) => (
                            <section key={i} className='container-charcater-and-cta'>
                                <Charcterswitch
                                    img={char.img}
                                    name={char.name}
                                    onPrev={prev}
                                    onNext={next} />
                                   {!char.unlocked ? (
                                    <div className='overlay-cta'>
                                        <SecondaryctaLong title='Locked' />
                                    </div>
                                ) : selectedCharacter === char.name ? (
                                    <PrimaryctaLong title='Selected' />
                                ) : (
                                    <div onClick={() => handleSelectCharacter(char.name)}>
                                        <SecondaryctaLong title='Select' />
                                    </div>
                                )}
                            </section>
                        ))}
                       
                    </section>
                </div>

                </section>
            </section>
          </main>

     );
}
 
export default Characters;